import { TEXT_KEYS } from '../../../constants/textKeys';
import IMAGES_PATH from '../../../Images';
import { t } from '../../../translation/translation';
import TitleImage from '../../common/TitleImage';
import './style.css'

const ModuleSection = () => {

    const title_1 = <h2>{t(TEXT_KEYS.MODULE_1_TITLE_1)} <h2 className='text-blue'>{t(TEXT_KEYS.MODULE_1_TITLE_2)}</h2></h2>
    const title_2 = <h2>{t(TEXT_KEYS.MODULE_2_TITLE_1)} <h2 className='text-blue'>{t(TEXT_KEYS.MODULE_2_TITLE_2)}</h2> {t(TEXT_KEYS.MODULE_2_TITLE_3)} <h2 className='text-blue'>{t(TEXT_KEYS.MODULE_2_TITLE_4)}</h2></h2>
    const title_3 = <h2>{t(TEXT_KEYS.MODULE_3_TITLE_1)} <h2 className='text-blue'>{t(TEXT_KEYS.MODULE_3_TITLE_2)}</h2> {t(TEXT_KEYS.MODULE_3_TITLE_3)} <h2 className='text-blue'>{t(TEXT_KEYS.MODULE_3_TITLE_4)}</h2> {t(TEXT_KEYS.MODULE_3_TITLE_5)}</h2>
    const title_4 = <h2>{t(TEXT_KEYS.MODULE_4_TITLE_1)} <h2 className='text-blue'>{t(TEXT_KEYS.MODULE_4_TITLE_2)}</h2> {t(TEXT_KEYS.MODULE_4_TITLE_3)} <h2 className='text-blue'>{t(TEXT_KEYS.MODULE_4_TITLE_4)}</h2> {t(TEXT_KEYS.MODULE_4_TITLE_5)}</h2>

    return (
        <div className='section'>
            <TitleImage
                title={title_1}
                subtitle={t(TEXT_KEYS.MODULE_1_SUBTITLE)}
                imagePath={IMAGES_PATH.MODULE_1}
            />
            <TitleImage
                title={title_2}
                subtitle={t(TEXT_KEYS.MODULE_2_SUBTITLE)}
                imagePath={IMAGES_PATH.MODULE_2}
                inverted={true}
            />
            <TitleImage
                title={title_3}
                subtitle={t(TEXT_KEYS.MODULE_3_SUBTITLE)}
                imagePath={IMAGES_PATH.MODULE_3}
            />
            <TitleImage
                title={title_4}
                inverted={true}
                imagePath={IMAGES_PATH.MODULE_4}
                subtitle={t(TEXT_KEYS.MODULE_4_SUBTITLE)}
            />
        </div>
    );
};

export default ModuleSection;